import { render } from "./TranslatedText.vue?vue&type=template&id=f329c066&scoped=true"
import script from "./TranslatedText.vue?vue&type=script&lang=js"
export * from "./TranslatedText.vue?vue&type=script&lang=js"

import "./TranslatedText.vue?vue&type=style&index=0&id=f329c066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f329c066"],['__file',"src/components/shared/TranslatedText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f329c066"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f329c066', __exports__)) {
    api.reload('f329c066', __exports__)
  }
  
  module.hot.accept("./TranslatedText.vue?vue&type=template&id=f329c066&scoped=true", () => {
    api.rerender('f329c066', render)
  })

}


export default __exports__